import pLimit, { type LimitFunction } from "p-limit";

// 薄い wrapper。テストで差し替えやすくするため。
export function createLimit(concurrency: number): LimitFunction {
  return pLimit(concurrency);
}
